import React from "react";
import Image_ContentReusableComponent from "../../component/ReusablaeComponent/Image_ContentReusableComponent";
import HeaderSectionReusableComponent from "../../component/ReusablaeComponent/HeaderSectionReusableComponent";
import PointsComponent from "../../component/ReusablaeComponent/PointsComponent";
import PointsWithHeading from "../../component/ReusablaeComponent/PointsWithHeading";
import ProductLifeCycle from '../../../Assets/Product_Life_Cycle.png'
import EmpowerBusiness from '../../../Assets/EmpowerBusiness.png'
import Communication from '../../../Assets/Communication.png'
import Benefits from '../../../Assets/Benefits.png';
import ecoFriendly from '../../../Assets/Eco-Friendly.png'

const PLM = () => {
  const features = [
    {
      strongText: "Collaboration and Communication:",
      text: "Seamlessly connect teams across R&D, engineering, manufacturing, and service departments.",
    },
    {
      strongText: " Version Control:",
      text: "Track and manage changes to product data, ensuring accuracy and consistency.",
    },
    {
      strongText: "Workflow Automation:",
      text: ": Streamline processes with configurable workflows for approvals, revisions, and tasks.",
    },
    {
      strongText: "Data Management:",
      text: " Maintain a single source of truth for all product-related information.",
    },
    {
      strongText: " Compliance Management:",
      text: "Ensure adherence to industry standards and regulations.",
    },
  ];
  const BenefitsPLM = [
    {
      strongText: "Deliver products to market faster:",
      text: "Optimize the design and delivery of new products to significantly speed up time-to-market. Gain a competitive edge and boost profits with pre-built, industry-specific features – made for your most complex manufacturing needs.",
    },
    {
      strongText: "Integrate seamlessly with other systems:",
      text: "Easily integrate with both Infor and non-Infor systems and platforms, including ERP, CAD, CRM, LIMS, and more. Smooth and robust system integrations deliver real-time reporting and data analysis.",
    },
    {
      strongText: "Make more informed decisions: ",
      text: "Gain AI-powered insights across the product lifecycle to enhance decision-making and foster collaboration between product, design, and engineering teams. Align business processes with value chain functions to enhance customer support.",
    },
    {
      strongText: "Establish a single source of truth:",
      text: "Reduce the silos and inefficiency that come from disconnected data and systems. With our product lifecycle management software, your teams can benefit from a unified version of product data from a single, centralized source. ",
    },
  ];
  return (
    <div>
      <Image_ContentReusableComponent
        heading="Comprehensive Product Lifecycle Management with PTKCS"
        paragraph="PTKCS Technologies offers powerful and scalable Product Lifecycle Management 
            (PLM) solutions that help organizations manage every phase of their product’s 
            journey—from the initial concept to design, development, manufacturing, and end-of-life. 
            We understand the growing complexity of product development in modern enterprises, and we 
            aim to simplify it with centralized, digital PLM systems. Our solutions are built to give 
            businesses total control and transparency over product-related data, workflows, documentation, 
            and collaboration—helping reduce lead times, improve quality, and accelerate innovation. Whether 
            you’re managing a single product or a diverse portfolio, PTKCS ensures your teams work in sync, 
            using accurate data and streamlined processes throughout the lifecycle."
        imgsrc={ProductLifeCycle}
        reverse={false}
        bgColor="#ffffff"
        headingColor="#e22d2dff"     // blue heading
        headingSize="2.5rem"       // custom font size
        textColor="#4B5563"        // gray text
      />


      <Image_ContentReusableComponent
        heading="PLM software for your industry"
        paragraph="Innovate, eliminate inefficiencies, and speed time to market with our cloud-based product lifecycle management (PLM) software solutions for fashion businesses, discrete manufacturers, and process manufacturers."
        imgsrc={ProductLifeCycle}
        reverse={true}
        bgColor="#ffffff"
        headingColor="#cc2029"     // blue heading
        headingSize="2.5rem"       // custom font size
        textColor="#4B5563"        // gray text
      />



      <PointsComponent
        title="A PLM system tailored to your industry and supply chain"
          description="Deliver exceptional products – with greater efficiency and profitability – using Infor PLM solutions. Create a PLM digital thread between data, processes, and teams to power your innovation and collaborate across the value chain:"
        listItems={[
          "Centralized data for complete lifecycle visibility",
          "Industry-specific features tailored to your needs",
          "Deep ERP integration for seamless workflows",
          "AI-driven insights to reduce costs and improve quality",
        ]}
        imageSrc={EmpowerBusiness}
        altText="EmpowerBusiness"
        reverse={false}
        headingColor="#cc2029"
        headingSize="2.5rem"
      />
      {/* <PointsWithHeading
        title="Key Features of Our PLM Solution"
        reverse={false}
        features={features}
        imageSrc={Communication}
        altText="Communication"
      /> */}
      <PointsWithHeading
        bgColor="#fff"
        headingColor="#cc2029"
        headingSize="2.5rem"
        title="Top benefits of our PLM software"
        features={BenefitsPLM}
        imageSrc={Benefits}
        altText="Benefits"
      />

      <h1 className="text-center font-bold m-10">Explore Our PLM Software Solutions</h1>
      <PointsComponent
        title="PLM for Process"
          description="A cloud-based PLM solution specifically designed for process manufacturers that readily integrates with ERP, CRM, and LIMS systems:"
        listItems={[
          "Maximize value with unified operations. Synchronize and automate product data across applications, validators, and workflows used by food, beverage, chemicals, and life science manufacturers.",
          "Support regulatory and customer compliance. Continuously monitor formulas to meet regulatory standards. Address complex food industry ingredient requirements and sustainability goals with accuracy.",
          "Support regulatory and customer compliance. Continuously monitor formulas to meet regulatory standards. Address complex food industry ingredient requirements and sustainability goals with accuracy.",
          "Optimize costs with process manufacturing capabilities. Highlight margin improvement and recipe cost-optimization opportunities using what-if scenarios. Gain insights into costs by leveraging the ERP integration.",
        ]}
        imageSrc={EmpowerBusiness}
        altText="EmpowerBusiness"
        reverse={false}
        headingColor="#cc2029"
        headingSize="2.5rem"
      />
      <PointsComponent
        title="PLM for Discrete"
          description="PLM for Discrete seamlessly integrates with ERP and CAD systems to improve design efficiency and get products to market faster and at a lower cost:"
        listItems={[
          "Make better product management decisions faster. View product information in real time across the lifecycle. Perform impact analysis proactively and before approval to better understand effects on cost, inventory, schedules, cycle time, and quality.",
          "Streamline your most complex processes. Collaborate effectively, shorten change and approval cycles, minimize rework, and boost productivity.",
          "Seamlessly integrate with multiple CADs and manufacturing systems. Enjoy pre-built integrations with both Infor solutions and third-party applications. Reduce implementation time and streamline workflows.",
          "Manage complex product portfolios and project-based challenges. Rely on robust PLM management, reporting, and analysis capabilities for MTO, CTO, ATO, and MTS manufacturing.",
        ]}
        imageSrc={EmpowerBusiness}
        altText="EmpowerBusiness"
        headingColor="#cc2029"
        headingSize="2.5rem"
      />
      <PointsComponent
        title="PLM for Fashion"
          description="A comprehensive PLM solution connecting every area of PLM for fashion, footwear, and apparel – from design to sourcing to production:"
        listItems={[
          "Connect design with data. Easily exchange concepts and data between Adobe® Illustrator and Infor Fashion PLM. Improve accuracy, reduce waste, and commercialize new styles faster.",
          "Accelerate design processes. Speed development using visual libraries, pre-configured templates, mass creation tools, image management, and much more.",
          "Streamline material and trim development. Enhance materials, trims, and BOM management, and create a component library to improve cost and optimize design.",
          "Work from anywhere on any device. Employees can access the systems and data they need anytime, anywhere, on PCs, Macs, tablets, and smartphones.",
        ]}
        imageSrc={EmpowerBusiness}
        altText="EmpowerBusiness"
        reverse={false}
        headingColor="#cc2029"
        headingSize="2.5rem"
      />
      {/* <Image_ContentReusableComponent
        reverse={false}
        heading={"PLM for Sustainability"}
        paragraph={
          <>
            Our PLM solution helps companies integrate sustainable practices
            throughout the product lifecycle. By optimizing material choices and
            reducing waste, businesses can minimize their environmental impact
            while improving efficiency. PLM supports eco-friendly product
            design, resource-efficient manufacturing, and sustainable supply
            chain management. It also enables lifecycle assessments (LCA) to
            evaluate the environmental impact of products and promotes a
            circular economy by designing for reuse and recycling. With built-in
            compliance tools, our PLM ensures adherence to global environmental
            regulations.
          </>
        }
        imgsrc={ecoFriendly}
        altText={ecoFriendly}
      /> */}
    </div>
  );
};

export default PLM;
